<template>
  <div id="wt-header-avatar-container">
    <b-avatar button variant="primary" :text="objUser.initials" class="align-baseline" v-b-toggle.user-settings></b-avatar>
    <span id="wt-header-avatar-desc" v-b-toggle.user-settings >{{objUser.fullName}}</span>
    <b-sidebar id="user-settings" right shadow>


<div class="page">
  <div class="page__container">
    <!--<article class="profile">
      <header class="profile__header mt-5">
        <img src="https://pt.gravatar.com/userimage/159521451/d51f2afa9f4e6b0e8379b89f9c9dc7d9.png" class="profile__avatar" alt="avatar of Stas Melnikov">
        <h3 class="profile__name">{{objUser.fullName}}</h3>
        <span class="profile__post">{{objUser.profession}}</span>
      </header>
      <div class="profile__stats">
        <div class="profile__group">
          <span class="profile__value">85%</span>
          <span class="profile__param">HTML</span>
        </div>
        <div class="profile__group">
          <span class="profile__value">90%</span>
          <span class="profile__param">CSS</span>
        </div>          
        <div class="profile__group">
          <span class="profile__value">85%</span>
          <span class="profile__param">Web-Design</span>
        </div>          
        <div class="profile__group">
          <span class="profile__value">98%</span>
          <span class="profile__param">Animation</span>
        </div>        
        <div class="profile__group">
          <span class="profile__value">52%</span>
          <span class="profile__param">Javascript</span>
        </div>        
        <div class="profile__group">
          <span class="profile__value">10%</span>
          <span class="profile__param">PHP</span>
        </div>                      
      </div>
      <footer class="profile__socials">
        <a href="#0" class="profile__social">
          <svg class="profile__social-icon"><use xlink:href="#twitter"></use></svg>
          <span class="profile__social-name">Logoff</span>
        </a>                     
      </footer>
    </article>-->
  </div>
</div>
<svg width="26" height="28" style="display: none;">
  <symbol id="twitter" viewBox="0 0 26 28">
    <path d="M25.312 6.375c-0.688 1-1.547 1.891-2.531 2.609 0.016 0.219 0.016 0.438 0.016 0.656 0 6.672-5.078 14.359-14.359 14.359-2.859 0-5.516-0.828-7.75-2.266 0.406 0.047 0.797 0.063 1.219 0.063 2.359 0 4.531-0.797 6.266-2.156-2.219-0.047-4.078-1.5-4.719-3.5 0.313 0.047 0.625 0.078 0.953 0.078 0.453 0 0.906-0.063 1.328-0.172-2.312-0.469-4.047-2.5-4.047-4.953v-0.063c0.672 0.375 1.453 0.609 2.281 0.641-1.359-0.906-2.25-2.453-2.25-4.203 0-0.938 0.25-1.797 0.688-2.547 2.484 3.062 6.219 5.063 10.406 5.281-0.078-0.375-0.125-0.766-0.125-1.156 0-2.781 2.25-5.047 5.047-5.047 1.453 0 2.766 0.609 3.687 1.594 1.141-0.219 2.234-0.641 3.203-1.219-0.375 1.172-1.172 2.156-2.219 2.781 1.016-0.109 2-0.391 2.906-0.781z"></path>
  </symbol>

</svg>
        

    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "wt-header-avatar",
  
  components: {},
  props: {},
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  data: function() {
    return {
      objUser: {}
    };
  },
  methods: {
    init() {
      this.objUser.firstName = this.user.access_key.substring(0,this.user.access_key.indexOf("."));
      this.objUser.lastName = this.user.access_key.substring(this.user.access_key.indexOf(".") + 1);
      this.objUser.fullName = this.objUser.firstName + ' ' + this.objUser.lastName
      this.objUser.initials =  this.objUser.firstName.substring(0,1) + this.objUser.lastName.substring(0,1)
      this.objUser.profession = 'Full Stack Developer'
      
    }
  },
 watch: {
    user() {
      if (Object.entries(this.user).length !== 0) {
        this.init()
      }      
    }
  },


};
</script>
<style >

.profile{
  box-sizing: border-box; 
  font-family: "Roboto Condensed", "Arial", sans-serif;
  font-size: 14px;
  font-weight: 400;  
  color: #222;
  
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12), 0 3px 1px -2px rgba(0, 0, 0, .2);
  text-align: center;
  
  position: relative;
  z-index: 0;
  overflow: hidden;
}

.profile:before{
  content: "";
  width: 85px;
  height: 50px;

  transition: transform .5s cubic-bezier(0.42, 0.04, 0.13, 0.92);
  border-radius: 50%;
  background-color: #03A9F4;

  position: absolute;
  top: -70px;
  left: 50%;
  z-index: -1;  
  transform: translateX(-50%) scale(7);
}

.profile:hover:before{
  transition: transform .7s cubic-bezier(0.66, 0.09, 0, 1.31);
  transform: translateX(-50%) translateY(200%) scale(25);
}

.profile:hover, .profile:hover .profile__value, .profile:hover .profile__social{
  color: #fff;
}

.profile:hover .profile__group, .profile:hover .profile__avatar{
  border-color: #fff;
}

.profile:hover .profile__stats{
  background-color: #0277BD;  
}

.profile__header{
  transition: color .4s ease-out .1s;  
}

.profile__avatar{
  border-radius: 50%;
  width: 120px;
  height: 100%;

  border: 6px solid #0277BD;
  transition: border-color .4s ease-out .1s;
}

.profile:hover .profile__avatar{
  transition-delay: .2s;
}

.profile__name{
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 30px;
}

.profile__stats{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;  

  margin-top: 25px;
  margin-bottom: 25px;  

  background-color: #f0f0f0;
  padding-top: 25px;
  padding-bottom: 25px;
  transition: background-color .4s ease-out .1s;
}

.profile:hover .profile__stats{
  transition-delay: .2s;
}

.profile__group{
  box-sizing: border-box;
  width: 33.3333333%;
  transition: border-color .4s ease-out .1s;

  border-right: 1px solid #BDBDBD;
  padding-left: 2%;
  padding-right: 2%;
}

profile:hover .profile__group{
  transition-delay: .4s;
}

.profile__group:nth-child(n+4){
  margin-top: 20px;
}

.profile__group:nth-child(3n+3){
  border-right: none;
}

.profile__param, .profile__value{
  display: block;
  transition: color .4s ease-out .1s;
}

.profile__param{
  text-transform: uppercase;
}

.profile__value{
  font-size: 30px;
  color: #03A9F4;
  font-weight: 700;
}

.profile__socials{
  padding-bottom: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile__social{
  border: 2px solid currentColor;
  color: #03A9F4;
  border-radius: 50%;
  transition: color .4s ease-out .3s;
  
  margin-left: 10px;
  margin-right: 10px;  
  padding: 10px;
  position: relative;
}

.profile__social-icon{
  width: 18px;
  height: 18px;
  display: block;
  fill: currentColor;
}

.profile__social-name{
  position: absolute;
  left: -9999px;
}

/*
* demo styles
*/



.page{
  height: 100%;
  display: flex;
  justify-content: space-between;
  background-color: #03A9F4;
}

.page__container{
  padding-left: 0px;
  padding-right: 0px;
  height: 100%;

}

.b-sidebar-body, .b-sidebar-header {
  background-color: #03A9F4;
}
</style>